/**
* @ngdoc directive
* @name Options Selector
*
* @description
  Options selector with next/previous, first/last option buttons
*
* @scope
* @param {Array<{ name: string }>} options - options to show in dropdown
* @param {String} emptyOptionName - shows name when no option selected
* @param {Function} onChange - callback fired when option changed
* @param {Number} selected - selected option number
*
* @example
  <options-selector
    options="[{ name: '2017-01-01' }]"
    empty-option-name="Select Week"
    on-change="function(val) { console.log(val); }"
  ></options-selector>
*/

(function () {
  app.directive('optionsSelector', ["PATH", function(PATH) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        emptyOptionName: '=',
        onChange: '=',
        selected: '=?'
      },
      templateUrl: PATH.components + 'optionsSelector/template.html',
      link: function ($scope) {
        $scope.goTo = function(optionIndex) {
          $scope.selected = $scope.options[optionIndex];
          $scope.onChange(optionIndex);
        };
      }
    };
  }]);
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/optionsSelector/directive.js